(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.topicFontFamily = _exports.subheading2LineHeight = _exports.subheading2FontWeight = _exports.subheading2FontSize = _exports.subheading1LineHeight = _exports.subheading1FontWeight = _exports.subheading1FontSize = _exports.separatorFontFamily = _exports.ruleFontFamily = _exports.inputLineHeight = _exports.inputFontWeight = _exports.inputFontSize = _exports.highlightedInputFontFamily = _exports.headlineLineHeight = _exports.headlineFontWeight = _exports.headlineFontSize = _exports.captionLineHeight = _exports.captionFontWeight = _exports.captionFontSize = _exports.buttonLineHeight = _exports.buttonFontWeight = _exports.buttonFontSize = _exports.body2LineHeight = _exports.body2FontWeight = _exports.body2FontSize = _exports.body1LineHeight = _exports.body1FontWeight = _exports.body1FontSize = _exports.baseLineHeight = _exports.baseFontWeight = _exports.baseFontSize = _exports.baseFontFamily = _exports.accentFontFamily = void 0;

  /*
   |------------------------------------------------------------------------------
   | Typefaces
   |------------------------------------------------------------------------------
   */

  var baseFontFamily = "Raleway, Helvetica, Arial, sans-serif";
  _exports.baseFontFamily = baseFontFamily;
  var accentFontFamily = "Venti CF, Raleway, Helvetica, Arial, sans-serif";
  _exports.accentFontFamily = accentFontFamily;
  var topicFontFamily = "Amiri, Georgia, Times, serif";
  _exports.topicFontFamily = topicFontFamily;
  var separatorFontFamily = "Amiri, Georgia, Times, serif";
  _exports.separatorFontFamily = separatorFontFamily;
  var highlightedInputFontFamily = "Amiri, Georgia, Times, serif";
  _exports.highlightedInputFontFamily = highlightedInputFontFamily;
  var ruleFontFamily = "Amiri, Georgia, Times, serif";

  /*
   |------------------------------------------------------------------------------
   | Measurements
   |------------------------------------------------------------------------------
   */
  _exports.ruleFontFamily = ruleFontFamily;
  var baseFontSize = 14;
  _exports.baseFontSize = baseFontSize;
  var baseFontWeight = 500;
  _exports.baseFontWeight = baseFontWeight;
  var baseLineHeight = 14;
  _exports.baseLineHeight = baseLineHeight;
  var headlineFontSize = 18;
  _exports.headlineFontSize = headlineFontSize;
  var headlineLineHeight = 21;
  _exports.headlineLineHeight = headlineLineHeight;
  var headlineFontWeight = 700;
  _exports.headlineFontWeight = headlineFontWeight;
  var subheading1FontSize = 15;
  _exports.subheading1FontSize = subheading1FontSize;
  var subheading1LineHeight = 18;
  _exports.subheading1LineHeight = subheading1LineHeight;
  var subheading1FontWeight = 700;
  _exports.subheading1FontWeight = subheading1FontWeight;
  var subheading2FontSize = 14;
  _exports.subheading2FontSize = subheading2FontSize;
  var subheading2LineHeight = 16;
  _exports.subheading2LineHeight = subheading2LineHeight;
  var subheading2FontWeight = 600;
  _exports.subheading2FontWeight = subheading2FontWeight;
  var body1FontSize = baseFontSize;
  _exports.body1FontSize = body1FontSize;
  var body1FontWeight = baseFontWeight;
  _exports.body1FontWeight = body1FontWeight;
  var body1LineHeight = baseLineHeight;
  _exports.body1LineHeight = body1LineHeight;
  var body2FontSize = 15;
  _exports.body2FontSize = body2FontSize;
  var body2LineHeight = baseLineHeight;
  _exports.body2LineHeight = body2LineHeight;
  var body2FontWeight = 700;
  _exports.body2FontWeight = body2FontWeight;
  var captionFontSize = 13;
  _exports.captionFontSize = captionFontSize;
  var captionLineHeight = 15;
  _exports.captionLineHeight = captionLineHeight;
  var captionFontWeight = baseFontWeight;
  _exports.captionFontWeight = captionFontWeight;
  var buttonFontSize = 15;
  _exports.buttonFontSize = buttonFontSize;
  var buttonFontWeight = 600;
  _exports.buttonFontWeight = buttonFontWeight;
  var buttonLineHeight = baseLineHeight;
  _exports.buttonLineHeight = buttonLineHeight;
  var inputLineHeight = baseLineHeight;
  _exports.inputLineHeight = inputLineHeight;
  var inputFontSize = 16;
  _exports.inputFontSize = inputFontSize;
  var inputFontWeight = baseFontWeight;
  _exports.inputFontWeight = inputFontWeight;
});